<template>
    <ModalComponent
        name="editar-observaciones"
        :title="'Editar observaciones para evento: ' + evento.nombre"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="editarObservaciones()">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label for="observaciones">Observaciones:</label>
                        <textarea class="form-control" id="observaciones" placeholder="Texto" v-model="observaciones"></textarea>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <Button type="submit" name="button" id="submit-comments">Editar</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>

    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['evento'],
        data() {
            return {
                observaciones: this.evento.observaciones
            }
        },
        methods: {
            close(editado) {
                this.$emit('close', 'editar-observaciones', editado);
            },
            editarObservaciones() {
                const data = {
                    filters: {},
                    evento_id: this.evento.id,
                    observaciones: this.observaciones
                };
                

                this.$store.dispatch(this.config.getVuexAlias('back.events.informe.observaciones'), data).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                    this.loading = false;
                });
            },
        },
        components: {
            ModalComponent
        }
    }
</script>
